<template>
    <div class="bg-white rounded shadow-sm py-3 my-2">
        <form class="kt-form" @submit.prevent="update" id="charge_sms_wallet_manually_form">
            <div class="d-flex align-items-center px-3">
                <div class="mr-auto d-flex align-items-center ">
                    <i class="fas fa-wallet text-primary"></i>
                    <div class="mx-2">{{ $t("notification.label.sms_wallet_title") }}</div>
                </div>
            </div>
            <hr/>
            <kt-form-section is_first>
                <kt-form-row>
                    <kt-col xs="6">
                        <kt-form-group>
                            <kt-form-label for="username">
                                {{ $t('notification.label.recharge_sms_wallet') }}
                            </kt-form-label>
                            <kt-form-control dir="rtl" name="sms_count_can_send" id="username"
                                             v-model="user.sms_count_can_send" placeholder="تعداد پیامک"
                                             type="number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col>
                        <div style="margin-top: 24px;" class="ml-auto">
                            <kt-form-action class="mt-4">
                                <button class="btn btn-md btn-success btn-wide" type="submit"
                                        id="charge_sms_wallet_manually_btn">
                                    {{ $t('btn.submit_changes') }}
                                </button>
                            </kt-form-action>
                        </div>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
        </form>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {userService} from "@/common/api.service";

export default {
    name: "ChargeSmsWalletManually",
    computed: {
        ...mapGetters('user', [
            'user'
        ])
    },
    data() {
        return {
            sms_numbers: 0,
            recharge_price: 0,
            recharge_price_currency_format: 0,
        };
    },
    methods: {
        // increment() {
        //     this.$store.dispatch("notificationSms/increment");
        // },
        // setRechargePrice() {
        //     this.recharge_price = this.sms_numbers * this.user.wallet_setting.sms_price;
        //     this.recharge_price_currency_format = this.moneyFormat(
        //             this.recharge_price
        //     );
        // },
        // moneyFormat(price) {
        //     const pieces = parseFloat(price).toFixed(0).split("");
        //     let ii = pieces.length;
        //     while ((ii -= 3) > 0) {
        //         pieces.splice(ii, 0, ",");
        //     }
        //     return pieces.join("");
        // },
        update(e) {
            let form = $('#charge_sms_wallet_manually_form')
            let btn = $('#charge_sms_wallet_manually_btn')

            form.validate({
                rules: {
                    sms_count_can_send: {
                        required: true,
                    },
                },
            });

            if (!form.valid()) {
                return
            }

            let params = {
                sms_count_can_send: this.user.sms_count_can_send,
                hashid: this.user.id,
            }

            KTApp.progress(btn)

            userService.update_wallet_sms_by_admin(params)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        },
    },
};
</script>
<style scoped>

</style>